import React, { useEffect, useState } from 'react'
import {
    Dimensions,
    TextInput,
    View,
    Text,
    Image,
    TouchableOpacity,
    StyleSheet,
} from 'react-native'
import { EvilIcons, Feather } from '@expo/vector-icons'
import { FlatList, ScrollView } from 'react-native-gesture-handler'
import RenderHTML from 'react-native-render-html'
import { useWindowDimensions } from 'react-native'
import theme from '../../../theme'
import { getAllPosts, openDB } from '../../db/indexDB'
import { get_learning } from '../../db/learning'
import { SearchModel } from './SearchModel'
import { getBenefitsVouchers } from '../../db/benefits'
import { getCategoriesWithSubcategoriesAndProducts } from '../../db/portfolio'
import PostFlags from '../posts/PostFlags'
import { FlashList } from '@shopify/flash-list'
import { FormHorizontalTags } from '../stores/FormHorizontalTags'
import { LEARNING_STATUS } from '../learning/constants'
import { useNavigation } from '@react-navigation/native'
import { onClickRedirect } from '../posts/Go_to'
import { getGoTo } from './context/GoToContext'
import { placeholderSearchView, placeholderLearning } from '../customUtils/Constants'
import styles from './SearchViewStyles'
import { getLanguage } from './context/LocalizationContext'
import { Loader } from '../customUtils/Components/Loader'
import { StatusBar } from 'react-native'
import { usePostContext } from '../posts/context/posts.context'

const { width } = Dimensions.get('window')

export const SearchView = ({ closeSearch }) => {
    const { setPostsContext } = usePostContext()

    const [originalData, setOriginalData] = useState([])
    const [searchData, setSearchData] = useState([])
    const [filteredData, setFilteredData] = useState([])
    const { languageFile } = getLanguage()

    const [labels, setLabels] = useState([{ _id: 0, name: languageFile.all }])
    const [searchText, setSearchText] = useState('')
    const [showNoReusults, setShowNoResults] = useState(false)
    const navigation = useNavigation()
    const { setBenefit, setPostID } = getGoTo()
    const [isLoading, setIsLoading] = useState(true)

    const onClickLabel = (label) => {
        let tag = ''
        switch (label) {
            case '0':
                tag = languageFile.all
                break
            case '1':
                tag = languageFile.wall
                break
            case '2':
                tag = languageFile.learning
                break
            case '3':
                tag = languageFile.benefits
                break
            case '4':
                tag = languageFile.portfolio
                break
            default:
                tag = languageFile.all
        }
        console.log('Este es mi id, tag y search', label, tag, searchText)
        // console.log('Este es mi tag', tag)

        if (tag !== languageFile.all) {
            let newData = originalData.filter(
                (item) => item.title.toLowerCase() == tag.toLowerCase(),
            )

            setSearchData(newData)
            filterByText(newData, searchText)
        } else {
            setSearchData(originalData)
            filterByText(originalData, searchText)
        }
    }

    const onChangeText = (text) => {
        setSearchText(text)
        filterByText(searchData, text)
    }

    const filterByText = (data, text) => {
        setFilteredData([])
        if (data && data.length > 0) {
            if (text.length > 0) {
                const allSearched = []
                data.forEach((item) => {
                    const searched = item.data.filter((item) => {
                        return item.title.toLowerCase().includes(text.toLowerCase())
                    })
                    allSearched.push({ ...item, data: searched })
                })
                setFilteredData(allSearched)
            } else {
                setFilteredData(data)
            }
        }
    }

    useEffect(() => {
        const openDatabase = async () => {
            try {
                const database = await openDB()
                getPoststoDB(database)
                getCourseDB(database)
                getBenefitsDB(database)
                getPortfolioDB(database)
            } catch (error) {
                console.error('Error opening databases', error)
            } finally {
                setIsLoading(false)
            }
        }
        openDatabase()
        return () => {}
    }, [])

    useEffect(() => {
        const checkData = () => {
            if (filteredData && filteredData.length > 0) {
                const hasContent = filteredData.some((item) => item.data.length > 0)
                setShowNoResults(!hasContent)
            }
        }
        checkData()
    }, [filteredData])

    useEffect(() => {
        setSearchData(originalData)
        // setFilteredData(originalData)
    }, [originalData])

    const getPoststoDB = async (db) => {
        getAllPosts(db, 0, -1)
            .then((posts) => {
                setPostsContext(posts)
                const postData = []
                posts.forEach((post) => {
                    const media =
                        (post.media_type === 'image' &&
                            post.medias &&
                            post.medias[0]?.media_url) ??
                        ''
                    const go_to = {
                        id_content: post._id,
                        type: 'interno',
                        path: 'wall',
                        text: 'Ver más',
                    }
                    const searchItem = {
                        _id: post._id ?? '',
                        title: post.title ?? '',
                        description: post.description_short ?? '',
                        media: media,
                        type: languageFile.wall,
                        go_to: go_to,
                    }

                    postData.push(searchItem)
                })

                const searchCategory = [
                    {
                        _id: '1',
                        title: languageFile.wall,
                        data: postData,
                    },
                ]
                if (postData.length > 0) {
                    setOriginalData((prevState) => [...prevState, ...searchCategory])
                    setLabels((prevState) => [
                        ...prevState,
                        { _id: 1, name: languageFile.wall },
                    ])
                }
            })
            .catch((error) => {
                console.error('Error al obtener registros:', error)
            })
    }
    const getCourseDB = async (db) => {
        const { categories, courses, contents } = await get_learning(db)
        const coursesData = []

        // categories.forEach((category) => {
        //     const go_to = {
        //         id_content: category._id,
        //         type: 'interno',
        //         path: 'learninghome',
        //         text: 'Ver más',
        //     }
        //     const searchItem = {
        //         _id: category._id ?? '',
        //         title: category.category_name ?? '',
        //         description: category.description ?? '',
        //         media: category.cover_image,
        //         status: category.status,
        //         type: 'Capacitación',
        //         go_to: go_to,
        //     }
        //     if (!coursesData.includes(searchItem)) {
        //         coursesData.push(searchItem)
        //     }
        // })
        courses.forEach((course) => {
            const go_to = {
                id_content: course._id,
                type: 'interno',
                path: 'course',
                text: 'Ver más',
            }
            const searchItem = {
                _id: course._id ?? '',
                title: course.title ?? '',
                description: course.description_short ?? '',
                media: course.cover_image,
                status: course.status,
                type: languageFile.learning,
                go_to: go_to,
            }

            if (!coursesData.includes(searchItem)) {
                coursesData.push(searchItem)
            }
        })
        // console.log('TAKAX', courses)
        // console.log('TOTAAAL DE INFO EN CURSO :', coursesData.length)
        {
            /*  contents.forEach((content) => {
            const go_to = {
                id_content: content._id,
                type: 'interno',
                path: 'content',
                text: 'Ver más',
            }
            const media = (content.media_slides && content.media_slides[0]?.media_url) ?? ''
            const searchItem = {
                _id: content._id ?? '',
                title: content.title ?? '',
                description: content.description_short ?? '',
                media: media,
                status: content.status,
                type: 'Capacitación',
                isContent: true,
                go_to: go_to,
            }
            if (!coursesData.includes(searchItem)) {
                coursesData.push(searchItem)
            }
        })
        */
        }
        const searchCategory = [
            {
                _id: '2',
                title: languageFile.learning,
                data: coursesData,
            },
        ]

        if (coursesData.length > 0) {
            setOriginalData((prevState) => [...prevState, ...searchCategory])
            setLabels((prevState) => [
                ...prevState,
                { _id: 2, name: languageFile.learning },
            ])
        }
    }
    const getBenefitsDB = async (db) => {
        let benefit_vouchers = await getBenefitsVouchers(db)
        const benefitsData = []
        benefit_vouchers.forEach((voucher) => {
            const go_to = {
                id_content: voucher._id,
                type: 'interno',
                path: 'benefits',
                text: 'Ver más',
                item: voucher,
            }
            const searchItem = {
                _id: voucher._id ?? '',
                title: voucher.title ?? '',
                description: voucher.description_short ?? '',
                media: voucher.cover_image,
                type: languageFile.benefits,
                go_to: go_to,
            }
            if (!benefitsData.includes(searchItem)) {
                benefitsData.push(searchItem)
            }
        })
        const searchCategory = [
            {
                _id: '3',
                title: languageFile.benefits,
                data: benefitsData,
            },
        ]

        if (benefitsData.length > 0) {
            setOriginalData((prevState) => [...prevState, ...searchCategory])
            setLabels((prevState) => [
                ...prevState,
                { _id: 3, name: languageFile.benefits },
            ])
        }
    }

    const getPortfolioDB = async (db) => {
        getCategoriesWithSubcategoriesAndProducts(db)
            .then((categories) => {
                const portfolioData = []

                categories.forEach((portfolio) => {
                    const go_to = {
                        id_content: portfolio._id,
                        type: 'interno',
                        path: 'portfolio',
                        text: 'Ver más',
                        item: portfolio,
                    }
                    const searchItem = {
                        _id: portfolio._id ?? '',
                        title: portfolio.name ?? '',
                        description: portfolio.description_short ?? '',
                        media: portfolio.image,
                        type: languageFile.portfolio,
                        go_to: go_to,
                    }
                    if (!portfolioData.includes(searchItem)) {
                        portfolioData.push(searchItem)
                    }
                })
                const searchCategory = [
                    {
                        _id: '4',
                        title: languageFile.portfolio,
                        data: portfolioData,
                    },
                ]
                if (portfolioData.length > 0) {
                    setOriginalData((prevState) => [...prevState, ...searchCategory])

                    setLabels((prevState) => [
                        ...prevState,
                        { _id: 4, name: languageFile.portfolio },
                    ])
                }
            })
            .catch((error) => {
                console.error(
                    'Error al obtener las categorías con subcategorías y productos:',
                    error,
                )
            })
    }
    const onClickSearch = async (go_to) => {
        console.log('click', go_to)
        if (go_to) {
            await onClickRedirect(go_to, navigation, setBenefit, setPostID).then(
                () => {
                    closeSearch()
                },
            )
        }
    }

    return (
        <View style={styles.containerFlex}>
            <View style={styles.containerFinder}>
                <View style={styles.inputBlock}>
                    <TextInput
                        style={styles.input}
                        onChangeText={onChangeText}
                        placeholder={languageFile.enter_your_search}
                        placeholderTextColor={theme.colors.inputPlaceholder}
                    />

                    <Feather
                        name='search'
                        size={24}
                        color={theme.colors.inputPlaceholder}
                    />
                </View>
            </View>

            <ScrollView
                style={styles.containerScrollTags}
                horizontal
                showsHorizontalScrollIndicator={false}
            >
                <View style={styles.containerTags}>
                    <FormHorizontalTags
                        tags={labels}
                        onClickTag={onClickLabel}
                        isSearch={true}
                    />
                </View>
            </ScrollView>

            {!showNoReusults && filteredData && filteredData.length > 0 ? (
                <View style={styles.containerFlex}>
                    {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}
                    {/* <ScrollView showsVerticalScrollIndicator={false}> */}
                    <FlatList
                        // Acá es donde está haciendo desaparecer el flat de labels
                        data={filteredData}
                        keyExtractor={(item, index) => index}
                        horizontal={false}
                        showsHorizontalScrollIndicator={false}
                        showsVerticalScrollIndicator={false}
                        renderItem={({ item: search }) => (
                            <SearchCategoryItem
                                item={search}
                                onClickSearch={onClickSearch}
                            />
                        )}
                    />
                    {/* </ScrollView> */}
                </View>
            ) : (
                <View style={styles.container}>
                    {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}
                    <Image
                        style={styles.image}
                        source={require('../../../assets/noSearchResults.png')}
                    />
                    <Text style={styles.title}>{languageFile.no_results}</Text>
                    <Text style={styles.description}>
                        {languageFile.search_content}
                    </Text>
                </View>
            )}
        </View>
    )
}

export const SearchCategoryItem = ({ item, onClickSearch }) => {
    const [show, setShow] = useState(true)
    const toggleShow = () => setShow(!show)
    const [showMoreItems, setShowMoreItems] = useState(false)

    const { languageFile } = getLanguage()

    return (
        <>
            {item.data && item.data.length > 0 && (
                <TouchableOpacity onPress={toggleShow}>
                    <View style={styles.containerTag}>
                        <Text style={styles.titleTag}>{'#' + item.title}</Text>
                        {/*
                        <Text style={styles.lengthTag}>
                            {item.data.length > 1 ? ' (' + item.data.length + ' resultados)' : ' (' + item.data.length + ' resultado)'}
                        </Text>
                        */}
                        <Feather
                            name={show ? 'chevron-up' : 'chevron-down'}
                            size={22}
                            color={theme.colors.colorPrimary}
                        />
                    </View>
                </TouchableOpacity>
            )}

            {show &&
                item.data
                    .slice(0, showMoreItems ? item.data.length : 4)
                    .map((item) => (
                        <SearchItem
                            key={item._id}
                            item={item}
                            onClickSearch={onClickSearch}
                        />
                    ))}

            {show && item.data && item.data.length > 4 && (
                <TouchableOpacity
                    onPress={() => setShowMoreItems(!showMoreItems)}
                    style={styles.seeMore}
                >
                    <Text style={styles.seeActive}>
                        {showMoreItems
                            ? languageFile.see_less_results
                            : languageFile.see +
                              ' ' +
                              item.data.length +
                              ' ' +
                              languageFile.results_in +
                              ' ' +
                              item.title}
                    </Text>
                </TouchableOpacity>
            )}
            {show && item.data && item.data.length < 4 && (
                <View style={styles.spacer} />
            )}
        </>
    )
}

export const SearchItem = ({ item, onClickSearch }) => {
    const { width: winWidth } = useWindowDimensions()
    return (
        <TouchableOpacity
            style={{ opacity: item.status === LEARNING_STATUS.BLOCKED ? 0.5 : 1 }}
            onPress={() =>
                item.status === LEARNING_STATUS.BLOCKED
                    ? () => {}
                    : onClickSearch(item.go_to)
            }
        >
            <View>
                <View style={styles.containerResults}>
                    <View style={styles.containerItem}>
                        {item.media && item.media != '' && (
                            <View>
                                <Image
                                    style={styles.imageModuleList}
                                    source={{
                                        uri:
                                            item.media && item.media != ''
                                                ? item.media
                                                : placeholderSearchView,
                                    }}
                                    errorSource={placeholderLearning}
                                    placeholder={placeholderLearning}
                                />
                            </View>
                        )}

                        <View style={styles.containerData}>
                            <View style={styles.dataAlign}>
                                {item.title && item.title !== '' && (
                                    <Text
                                        style={styles.titleModuleList}
                                        numberOfLines={2}
                                    >
                                        {item.title}
                                    </Text>
                                )}
                                {item.description && item.description !== '' && (
                                    <RenderHTML
                                        source={{ html: item.description }}
                                        baseStyle={styles.descriptionModuleList}
                                        defaultTextProps={{
                                            numberOfLines: 2,
                                            allowFontScaling: false,
                                        }}
                                        contentWidth={winWidth}
                                    />
                                )}

                                {item.status ? (
                                    <View style={styles.containerStatus}>
                                        <StatusTagSwitch status={item.status} />
                                    </View>
                                ) : (
                                    <></>
                                )}
                            </View>
                        </View>

                        <View>
                            {item.status === 0 ? (
                                <Feather
                                    name='lock'
                                    size={22}
                                    color={theme.colors.colorPrimary}
                                />
                            ) : (
                                <Feather
                                    name='chevron-right'
                                    size={24}
                                    color={theme.colors.colorPrimary}
                                />
                            )}
                        </View>
                    </View>
                </View>
            </View>
        </TouchableOpacity>
    )
}

export const StatusTagSwitch = ({ status }) => {
    const { languageFile } = getLanguage()

    return (
        <>
            {status === LEARNING_STATUS.REPROBADO && (
                <StatusTagView
                    text={languageFile.retry}
                    color={theme.colors.colorRetry}
                />
            )}
            {status === LEARNING_STATUS.BLOCKED && (
                <StatusTagView
                    text={languageFile.locked}
                    color={theme.colors.colorLocked}
                />
            )}
            {status === LEARNING_STATUS.PENDIENTE && (
                <StatusTagView
                    text={languageFile.pending}
                    color={theme.colors.colorPending}
                />
            )}
            {status === LEARNING_STATUS.VIEWED && (
                <StatusTagView
                    text={languageFile.seen}
                    color={theme.colors.colorSeen}
                />
            )}
            {status === LEARNING_STATUS.COMPLETED && (
                <StatusTagView
                    text={languageFile.approved}
                    color={theme.colors.colorApproved}
                />
            )}
        </>
    )
}

export const StatusTagView = ({ text, color }) => {
    return (
        <View
            style={[
                styles.statusModuleList,
                { backgroundColor: color || theme.colors.colorPending },
            ]}
        >
            <Text style={styles.statusModuleText} numberOfLines={1}>
                {text.toUpperCase()}
            </Text>
        </View>
    )
}
